import React from 'react'
import Table from '../presentation/Table.js'
import {
  CSSTransition,
  TransitionGroup,
} from 'react-transition-group';

class TableLayout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.updateRowHeights()
    this.resizeFreeCtaTable()
  }

  componentDidUpdate() {
    this.updateRowHeights()
    this.resizeFreeCtaTable()
  }

  updateRowHeights() {
    // aligns row heights on table view, matches the height of the row to that of the largest cell
    if (!this.props.fields) { return }
    this.props.fields.slice(0, this.props.tableFieldCount).map(f => {

      const cells = Array.prototype.slice.call(document.querySelectorAll(`[data-field-key="${f.key}"]`))

      let maxHeight = 0

      for(let i = 0; i < cells.length; i++) {
        const cellHeight = cells[i].offsetHeight

        if(maxHeight < cellHeight) {
          maxHeight = cellHeight
        }
      }

      for(let i = 0; i < cells.length; i++) {
        cells[i].style.height = maxHeight + 'px'
      }

    })
  }

  resizeFreeCtaTable() {
    const tableElement = document.querySelector('.table-element')
    if(this.props.freeAccess == true && this.props.hasFreeAccessCta && tableElement !== null) {
      document.querySelector('.cta-table-container').style.minHeight = tableElement.offsetHeight + 'px'
    }
  }

  handleClick(e) {
    this.props.updateScrollPosition(parseInt(e.target.getAttribute('value')))
  }

  getLayoutFromAccessLevel() {
    if(this.props.accessLevel == 'bronze') {
      return <div className="table-overlay" dangerouslySetInnerHTML={{__html: this.props.getAccessPartial}}></div>
    }
  }

  displayTiles(servicesToCompare) {
    let tiles = servicesToCompare.map((i, index) => (
      <CSSTransition key={i.id} timeout={500} classNames="services-table" >
        <Table key={i.id}
             values={i}
             handleRemoveItem={this.props.handleRemoveItem}
             filterKey={this.props.filterKey}
             tableFieldCount={this.props.tableFieldCount}
             accessLevel={this.props.accessLevel}
             index={index}
             totalServiceCount={this.props.servicesToCompare.length}
             directoryFreeExplanationPartialTable={this.props.directoryFreeExplanationPartialTable}
             freeAccess={this.props.freeAccess}
             {...this.props} />
      </CSSTransition>
      )
    );

    if (this.props.freeAccess == true && this.props.hasFreeAccessCta) {
      tiles.splice(tiles.length ? 1 : 0, 0,
        <CSSTransition key={'donate-cta'} timeout={500} classNames="services-table" >
          <Table key={'donate-cta'}
            isDonateCTA
            handleRemoveItem={this.props.handleRemoveItem}
            filterKey={this.props.filterKey}
            tableFieldCount={this.props.tableFieldCount}
            accessLevel={this.props.accessLevel}
            totalServiceCount={this.props.servicesToCompare.length}
            directoryFreeExplanationPartialTable={this.props.directoryFreeExplanationPartialTable}
            freeAccess={this.props.freeAccess}
            {...this.props} />
        </CSSTransition>
      );
    }
    return tiles;
  }

  render() {

    let servicesToCompare = this.props.servicesToCompare

    const totalServiceCount = this.props.servicesToCompare.length
    const offset = (this.props.scrollPosition * 187.5) + 'px'
    const leftButtonActive = this.props.scrollPosition < 0
    const rightButtonActive = this.props.scrollPosition > - totalServiceCount + this.props.maxScrollPosition
    const paywallMinHeight = this.props.accessLevel === 'bronze' ? {minHeight: '835px'} : {}

    return (
      <section className="w-80-ns flex overflow-hidden table-layout relative" style={paywallMinHeight}>
        <div className="absolute w-100 flex pl7">
          <div className="arrows-container flex w7 mla mra items-center b">
            <div onClick={this.handleClick.bind(this)} value="1" className={`ml3 br2 pointer button-active-${leftButtonActive}`}></div>
            <div onClick={this.handleClick.bind(this)} value="-1" className={`ml3 br2 pointer button-active-${rightButtonActive}`}></div>
          </div>
        </div>

        <div className={`fields-container z3 overflow-y-hidden overflow-x-hidden w5 flex-shrink-0 flex-grow-0 br b--light-silver flex flex-column ${this.props.accessLevel === 'bronze' ? 'bronze' : ''}`}>
          {!!this.props.fields && this.props.fields.slice(0, this.props.tableFieldCount).map(f =>
              f.key === 'peoples-choice' ? null :
                  <div data-field-key={f.key} key={f.id} className="bt b--light-silver pv2 ph2 small ml4 min-h4 flex relative">
              <p className={`b ${f.id}`}> {f.label}</p>
            </div>
          )}
        </div>

        {this.getLayoutFromAccessLevel()}


        <TransitionGroup style={{marginLeft: offset}} className="w-100 flex pt5 pl3 table-container items-start">
          {this.displayTiles(servicesToCompare)}
        </TransitionGroup>
      </section>
      )
  }
}

export default TableLayout
